import { pageLoadingStatusMixin } from 'relapp-loading';
import { mapGetters } from 'vuex';
import ServersApi from '../services/api/server.js';

export default {
    mixins: [pageLoadingStatusMixin],
    computed: {
        ...mapGetters({
            servers: 'servers/items'
        }),
        /**
         * Generate the table data array from the servers.
         *
         * @return {array}
         */
        tableData() {
            return this.servers.map(dataItem => {
                let websites = dataItem.number_of_websites;

                let ipAddresses = dataItem.ipv4 + ' / ' + dataItem.ipv6;

                if (dataItem.maximum_websites) {
                    websites = dataItem.number_of_websites + ' / ' + dataItem.maximum_websites;
                }

                return {
                    ...dataItem,
                    ip_addresses: ipAddresses,
                    websites: websites
                };
            });
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServers();
    },
    methods: {
        /**
         * Get the subscriptions.
         */
        getServers() {
            ServersApi.get().then(this.finishLoading);
        }
    }
};
